var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { removeVeiculoEdicaoInProcesso } from '../../services/processo-veiculo-edicao.service';
import { Attachment } from '../Form/Attachment';
export var VeiculoDescredenciamentoModal = function (_a) {
    var open = _a.open, processo = _a.processo, veiculo = _a.veiculo, onClose = _a.onClose;
    var navigate = useNavigate();
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), descredenciamentoFile = _c[0], setDescredenciamentoFile = _c[1];
    var _d = useState(null), attachment = _d[0], setAttachment = _d[1];
    var handleFileChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var file, documento;
        var _a;
        return __generator(this, function (_b) {
            file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
            if (file) {
                setDescredenciamentoFile(file);
                documento = {
                    id: 0,
                    nomeOriginal: file.name,
                    tamanhoArquivo: file.size,
                    arquivoTipo: file.type,
                    keyArquivo: '0',
                    servicoDocumentoId: 0,
                };
                setAttachment(documento);
            }
            return [2 /*return*/];
        });
    }); };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    return [4 /*yield*/, removeVeiculoEdicaoInProcesso(processo.processoEdicaoId, veiculo.id, descredenciamentoFile !== null && descredenciamentoFile !== void 0 ? descredenciamentoFile : undefined)];
                case 1:
                    _b.sent();
                    enqueueSnackbar('Veículo excluído com sucesso!', {
                        variant: 'success',
                    });
                    navigate(0);
                    return [3 /*break*/, 4];
                case 2:
                    _a = _b.sent();
                    enqueueSnackbar('Erro ao excluir veículo. Tente novamente.', {
                        variant: 'error',
                    });
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: "lg", children: [_jsx(DialogTitle, { children: "Excluir cadastro de ve\u00EDculo" }), _jsxs(DialogContent, { children: [_jsx(Typography, { variant: "body2", color: "textSecondary", sx: { mb: 2 }, children: "Voc\u00EA deve inserir o requerimento de descredenciamento de ve\u00EDculos!" }), _jsxs(Button, { variant: "outlined", fullWidth: true, component: "label", startIcon: _jsx(AttachFileIcon, {}), disabled: loading, children: ["Anexar Arquivo", _jsx("input", { type: "file", hidden: true, onChange: handleFileChange, accept: ".pdf" })] }), attachment && (_jsx(Box, { children: _jsx(Attachment, { file: attachment }) }))] }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, children: "Cancelar" }), _jsx(Button, { variant: "contained", color: "primary", type: "submit", onClick: onSubmit, disabled: !descredenciamentoFile || loading, children: !loading ? 'Confirmar Exclusão' : 'Excluindo' })] })] }));
};
